import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { get, post } from '../../util/api';

// ================ Action types ================ //

const FETCH_COMPANY_PAGE_REQUEST = 'app/WelfarePage/FETCH_COMPANY_PAGE_REQUEST';
const FETCH_COMPANY_PAGE_SUCCESS = 'app/WelfarePage/FETCH_COMPANY_PAGE_SUCCESS';
const FETCH_COMPANY_PAGE_ERROR = 'app/WelfarePage/FETCH_COMPANY_PAGE_ERROR';

const ACTIVATE_VOUCHER_REQUEST = 'app/WelfarePage/ACTIVATE_VOUCHER_REQUEST';
const ACTIVATE_VOUCHER_SUCCESS = 'app/WelfarePage/ACTIVATE_VOUCHER_SUCCESS';
const ACTIVATE_VOUCHER_ERROR = 'app/WelfarePage/ACTIVATE_VOUCHER_ERROR';
const ACTIVATE_VOUCHER_RESET = 'app/WelfarePage/ACTIVATE_VOUCHER_RESET';

// ================ Reducer ================ //

const initialState = {
  companyData: null,
  fetchInProgress: false,
  fetchError: null,
  activateInProgress: false,
  activateError: null,
  activateSuccess: null,
};

export default function welfarePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_COMPANY_PAGE_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_COMPANY_PAGE_SUCCESS:
      return { ...state, fetchInProgress: false, companyData: payload };
    case FETCH_COMPANY_PAGE_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };

    case ACTIVATE_VOUCHER_REQUEST:
      return { ...state, activateInProgress: true, activateError: null, activateSuccess: null };
    case ACTIVATE_VOUCHER_SUCCESS:
      return { ...state, activateInProgress: false, activateSuccess: payload };
    case ACTIVATE_VOUCHER_ERROR:
      return { ...state, activateInProgress: false, activateError: payload };
    case ACTIVATE_VOUCHER_RESET:
      return { ...state, activateError: null, activateSuccess: null };

    default:
      return state;
  }
}

// ================ Thunks ================ //

export const fetchCompanyPage = slug => (dispatch) => {
  dispatch({ type: FETCH_COMPANY_PAGE_REQUEST });

  return get(`/api/companies/page/${slug}`)
    .then(response => {
      dispatch({ type: FETCH_COMPANY_PAGE_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_COMPANY_PAGE_ERROR, payload: storableError(e) });
    });
};

export const activateVoucher = code => (dispatch) => {
  dispatch({ type: ACTIVATE_VOUCHER_REQUEST });

  return post('/api/convert-voucher-to-wallet', { voucherCode: code })
    .then(response => {
      dispatch({ type: ACTIVATE_VOUCHER_SUCCESS, payload: response });
      // Refresh user data to get updated wallet balance
      dispatch(fetchCurrentUser());
      return response;
    })
    .catch(e => {
      // Preserve the API error code (e.g. 'NOT_INVITED', 'EXPIRED', 'LIMIT_REACHED')
      // The fetch helper does `Object.assign(e, responseBody)` so e.error = the code
      dispatch({ type: ACTIVATE_VOUCHER_ERROR, payload: { ...storableError(e), code: e.error || null } });
      throw e;
    });
};

export const resetActivation = () => ({ type: ACTIVATE_VOUCHER_RESET });

export const loadData = (params) => (dispatch) => {
  const { slug } = params;
  return Promise.all([
    dispatch(fetchCompanyPage(slug)),
    dispatch(fetchCurrentUser()),
  ]);
};
